export const APP_CONFIG_DEFAULTS = {
    supportsChatInput: true,
    supportsVideoInput: true,
    supportsScreenShare: true,
    isPreConnectBufferEnabled: false,
};
